import { render, staticRenderFns } from "./GbsHelpUploader.vue?vue&type=template&id=e6f90b18"
import script from "./GbsHelpUploader.vue?vue&type=script&lang=ts"
export * from "./GbsHelpUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports